<template>
    <div :class="['techKit reveal']">
        <div class="techGrid">
            <div class="kitDesc" > 
                <div v-html="componentData.content">
                </div>
            </div>
            <div class="kitImg">
                <img :src="'http://mis-implants.com/upload'+componentData.files[0].file_url"/>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .techGrid
    {
        display: flex;
        flex-direction: row;            
        width: 80%;
        max-width: 1200px;
        margin: auto;
        column-gap: 20px;
        padding-top: 40px;
    }
    .kitDesc
    {
        text-align: left;
        display: flex;
        align-items: center;
        border: solid 0px red;
    }
    .kitImg
    {
        display: flex;
        align-items: center;        
        text-align: center;
    }
    .kitImg img
    {
        height: 30vw;
        width: auto;
        margin: auto;
    }

@media (max-width: 850px) 
{ 
    .techGrid
    {
        flex-direction: column-reverse;
        gap: 40px;
        padding-bottom: 40px;
        padding-top: 0px;
    }
    .kitImg img
    {
        height: 50vw;
    }

}

@media (max-width: 850px) and (orientation:landscape) {

}

  @media (hover: hover){
  }
</style>

<script>
    import { mapActions, mapState } from "vuex";
    import splitter from "@/views/com/splitter.vue";
    import sidepager from "@/views/com/sidepager.vue";
    import { splitLines,isMobileScreen }         from "@/utils";

    export default {
        components:{splitter,sidepager},
        props: 
        {
            sectionType:String,
            sectionIndex:Number,            
            sectionDataIndex:Number,
            openIndex:Number            
        },     
        mounted()
        {
            this.componentData = this.getSiteTechTabData();
        },
        destroyed() {
        },
        methods:
        {
            getSiteTechTabData()
            {
                var pageSections = this.pageLayoutData.children[0].children;        
                var techTabsSection = pageSections.filter(x => x.type == "propage-technical");
                var targetNodes = techTabsSection[0].children[0].children;
                var targetNode = targetNodes[this.sectionIndex];//.filter(x => x.template == this.sectionType)[0];
                return targetNode;
            },
        },
        data()
        {
            return {
                slideIndex:0,
                componentData:[]
                }
        },
        computed:
        {
            ...mapState(["pageLayoutData","xSelectedPlatform","minisite_data","siteDataReady"])
        }        
    }
</script>  
